<template>
  <div class="pb-2">
    <div v-if="this.loadpage == false" class="text-center">
      <b-spinner
        style="width: 5rem; height: 5rem;"
        variant="primary"
        label="Large Spinner"
      />
    </div>
    <div v-if="this.loadpage == true">
      <b-card>
        <!-- pc timeline -->
        <div class="py-1 d-none d-sm-block" v-if="this.statList[0] != null">
          <h3 class="text-center pb-1">สถานะออเดอร์</h3>
          <app-timeline class="d-flex justify-content-center">
            <app-timeline-item
              :title="this.statList[0].statusText"
              :subtitle="this.statList[0].date"
              :color="this.statList[0].active == false ? 'text-secondary': null"
              :variant="this.statList[0].active == true ? 'success': 'secondary'"
              icon="FileTextIcon"
            />
            <div class="pr-2 d-none d-sm-block">
              <feather-icon
                class="icon"
                :class="this.statList[0].active == false ? 'text-secondary': null"
                icon="ChevronRightIcon"
                size="15"
              />
            </div>
            <app-timeline-item
              :title="this.statList[1].statusText"
              :subtitle="this.statList[1].date"
              :color="this.statList[1].active == false ? 'text-secondary': null"
              :variant="this.statList[1].active == true ? 'success': 'secondary'"
              icon="PackageIcon"
            />
            <div class="pr-2 d-none d-sm-block">
              <feather-icon
                class="icon"
                :class="this.statList[1].active == false ? 'text-secondary': null"
                icon="ChevronRightIcon"
                size="15"
              />
            </div>
            <app-timeline-item
              :title="this.statList[2].statusText"
              :subtitle="this.statList[2].date"
              :color="this.statList[2].active == false ? 'text-secondary': null"
              :variant="this.statList[2].active == true ? 'success': 'secondary'"
              icon="HomeIcon"
            />
            <div class="pr-2 d-none d-sm-block">
              <feather-icon
                class="icon"
                :class="this.statList[2].active == false ? 'text-secondary': null"
                icon="ChevronRightIcon"
                size="15"
              />
            </div>
            <app-timeline-item
              :title="this.statList[3].statusText"
              :subtitle="this.statList[3].date"
              :color="this.statList[3].active == false ? 'text-secondary': null"
              :variant="this.statList[3].active == true ? 'success': 'secondary'"
              icon="TruckIcon"
            />
            <div class="pr-2 d-none d-sm-block">
              <feather-icon
                class="icon"
                :class="this.statList[3].active == false ? 'text-secondary': null"
                icon="ChevronRightIcon"
                size="15"
              />
            </div>
            <app-timeline-item
              :title="this.statList[4].statusText"
              :subtitle="this.statList[4].date"
              :color="this.statList[4].active == false ? 'text-secondary': null"
              :variant="this.statList[4].active == true ? 'success': 'secondary'"
              icon="MapPinIcon"
            />
            <div class="pr-2 d-none d-sm-block">
              <feather-icon
                class="icon"
                :class="this.statList[4].active == false ? 'text-secondary': null"
                icon="ChevronRightIcon"
                size="15"
              />
            </div>
            <app-timeline-item
              :title="this.statList[5].statusText"
              :subtitle="this.statList[5].date"
              :color="this.statList[5].active == false ? 'text-secondary': null"
              :variant="this.statList[5].active == true ? 'success': 'secondary'"
              icon="CreditCardIcon"
            />
            <div class="pr-2 d-none d-sm-block">
              <feather-icon
                class="icon"
                :class="this.statList[5].active == false ? 'text-secondary': null"
                icon="ChevronRightIcon"
                size="15"
              />
            </div>
            <app-timeline-item
              :title="this.statList[6].statusText"
              :subtitle="this.statList[6].date"
              :color="this.statList[6].active == false ? 'text-secondary': null"
              :variant="this.statList[6].active == true ? 'success': 'secondary'"
              icon="CheckCircleIcon"
            />
          </app-timeline>
        </div>

        <!-- mobile timeline -->
        <div class="d-block d-sm-none" role="tablist" no-body v-if="this.statList[0] != null">
          <span header-tag="header" class="px-0 py-0 d-flex" role="tab">
            <h3 class="col-8 px-0">สถานะออเดอร์</h3>
            <div class="col-4 px-0 text-right">
              <b-button
                variant="flat-primary"
                class="btn-icon rounded-circle pr-0"
                v-b-toggle="'status'"
              >
                <span class="when-opened">
                  <feather-icon icon="ChevronUpIcon" />
                </span>
                <span class="when-closed">
                  <feather-icon icon="ChevronDownIcon" />
                </span>
              </b-button>
            </div>
          </span>
          <b-collapse :id="'status'" accordion="status" role="tabpanel">
            <b-card-body class="py-0">
              <app-timeline class="justify-content-center">
                <app-timeline-item
                  :title="this.statList[0].statusText"
                  :subtitle="this.statList[0].date"
                  :color="this.statList[0].active == false ? 'text-secondary': null"
                  :variant="this.statList[0].active == true ? 'success': 'secondary'"
                  icon="FileTextIcon"
                />
                <app-timeline-item
                  :title="this.statList[1].statusText"
                  :subtitle="this.statList[1].date"
                  :color="this.statList[1].active == false ? 'text-secondary': null"
                  :variant="this.statList[1].active == true ? 'success': 'secondary'"
                  icon="PackageIcon"
                />
                <app-timeline-item
                  :title="this.statList[2].statusText"
                  :subtitle="this.statList[2].date"
                  :color="this.statList[2].active == false ? 'text-secondary': null"
                  :variant="this.statList[2].active == true ? 'success': 'secondary'"
                  icon="HomeIcon"
                />
                <app-timeline-item
                  :title="this.statList[3].statusText"
                  :subtitle="this.statList[3].date"
                  :color="this.statList[3].active == false ? 'text-secondary': null"
                  :variant="this.statList[3].active == true ? 'success': 'secondary'"
                  icon="TruckIcon"
                />
                <app-timeline-item
                  :title="this.statList[4].statusText"
                  :subtitle="this.statList[4].date"
                  :color="this.statList[4].active == false ? 'text-secondary': null"
                  :variant="this.statList[4].active == true ? 'success': 'secondary'"
                  icon="MapPinIcon"
                />
                <app-timeline-item
                  :title="this.statList[5].statusText"
                  :subtitle="this.statList[5].date"
                  :color="this.statList[5].active == false ? 'text-secondary': null"
                  :variant="this.statList[5].active == true ? 'success': 'secondary'"
                  icon="CreditCardIcon"
                />
                <app-timeline-item
                  :title="this.statList[6].statusText"
                  :subtitle="this.statList[6].date"
                  :color="this.statList[6].active == false ? 'text-secondary': null"
                  :variant="this.statList[6].active == true ? 'success': 'secondary'"
                  icon="CheckCircleIcon"
                />
              </app-timeline>
            </b-card-body>
          </b-collapse>
        </div>

        <b-row >
          <b-col cols="12" class="pt-1 mb-md-n1">
            <b-form-group class="font-weight-slim" label-class="pt-0" label="เวลาสร้างบิล :" label-cols-md="3">
              <div>{{formatDatetime(this.infoList.createDate)}}</div>
            </b-form-group>
          </b-col>
          <b-col cols="12" class="mb-md-n1">
            <b-form-group class="font-weight-slim" label-class="pt-0" label="เลขบิล :" label-cols-md="3">
              <div>{{this.infoList.billNumber}}</div>
            </b-form-group>
          </b-col>
          <b-col cols="12" class="mb-md-n1">
            <b-form-group class="font-weight-slim" label-class="pt-0" label="รหัสจ่าหน้า :" label-cols-md="3">
              <div>{{this.infoList.addressCode}}</div>
            </b-form-group>
          </b-col>
          <b-col cols="12" class="mb-md-n1">
            <b-form-group class="font-weight-slim" label-class="pt-0" label="ชื่อบริษัท :" label-cols-md="3">
              <div>{{this.vCompanyName}}</div>
            </b-form-group>
          </b-col>
          <b-col cols="12" class="mb-md-n1">
            <b-form-group class="font-weight-slim" label-class="pt-0" label="ที่อยู่จัดส่ง :" label-cols-md="3">
              <div>{{this.vAddress}}</div>
            </b-form-group>
          </b-col>
          <b-col cols="12" class="mb-md-n1">
            <b-form-group class="font-weight-slim" label-class="pt-0" label="รูปแบบการจัดส่ง :" label-cols-md="3">
              <div>{{this.vTransType}}</div>
            </b-form-group>
          </b-col>
          <b-col cols="12" class="mb-md-n1">
            <b-form-group class="font-weight-slim" label-class="pt-0" label="ขนส่งภายในประเทศ :" label-cols-md="3">
              <div>{{this.vExpress}}</div>
            </b-form-group>
          </b-col>
          <b-col cols="12" class="mb-md-n1">
            <b-form-group class="font-weight-slim" label-class="pt-0" label="ไฟล์ Invoice :" label-cols-md="3">
              <b-link :href="this.infoList.invoiceFile" target="_blank"><u>ดาวน์โหลด</u></b-link>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group class="font-weight-slim" label-class="pt-0" label="ไฟล์ Packing List :" label-cols-md="3">
              <b-link :href="this.infoList.packingListFile" target="_blank"><u>ดาวน์โหลด</u></b-link>
            </b-form-group>
          </b-col>
        </b-row>

        <b-table
          responsive
          :items="requestList"
          :fields="requestFields"
          fixed
          table-class="table-md-responsive text-nowrap"
        >
          <template #cell(requestFormE)="data">
            <feather-icon
              :icon="data.value == true ? 'CheckIcon' : 'XIcon'"
              :class="data.value == true ? 'text-success' : 'text-danger'"
              size="35"
            />
          </template>
          <template #cell(requestTaxRefund)="data">
            <feather-icon
              :icon="data.value == true ? 'CheckIcon' : 'XIcon'"
              :class="data.value == true ? 'text-success' : 'text-danger'"
              size="35"
            />
          </template>
          <template #cell(requestTransportOwnName)="data">
            <feather-icon
              :icon="data.value == true ? 'CheckIcon' : 'XIcon'"
              :class="data.value == true ? 'text-success' : 'text-danger'"
              size="35"
            />
          </template>
        </b-table>

        <b-table
          class="position-relative col-md-6 float-right px-0 pl-md-1"
          thead-class="hidden_header"
          responsive
          small
          borderless
          :items="totalPriceList"
          :fields="totalPriceFields"
        >
        </b-table>
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BRow, BCol, BButton, BCard, BCardHeader, BCardBody, BModal, VBToggle, BAvatar, BContainer, BLink, BTable,
  BSpinner, BImg, BFormCheckbox, BTooltip, BFormRadioGroup, BFormRadio, BFormGroup, BForm, BFormFile,
  BFormInput, VBModal, BFormTextarea, BCollapse
} from 'bootstrap-vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import { format_price, formatDatetime, formatDate_thaiShort} from '@/views/global_function.js'
import axios from "axios";
import {header_token} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
export default {
  name: 'Taobao2youViewInfo',

  directives: {
    'b-toggle': VBToggle,
    'b-modal': VBModal
  },

  components: {
    BRow, BCol, BButton, BCard, BCardHeader, BCardBody, BModal, VBToggle, BLink, BTable, BSpinner, BFormGroup, BForm,
    AppTimeline, AppTimelineItem, BCollapse
  },

  data() {
    return {
      postcodeMapping: [],
      expressList: [],
      companyList: [],
      transportList: [],

      makeBoxList: [
        { text: 'ไม่ตีลังไม้', value: false },
        { text: 'ตีลังไม้', value: true },
      ],

      requestList: [],
      requestFields: [
        { key: 'requestFormE', label: 'ขอ Form E', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'requestTaxRefund', label:'ทำ Tax Refund', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'requestTransportOwnName', label: 'ทำใบขนส่งเป็นชื่อตัวเอง', thClass: 'text-center', tdClass: 'text-center' },
      ],
      totalPriceList: [],
      totalPriceFields:[
        { key: 'description' },
        { key: 'amount', tdClass: 'text-right'},
        { key: 'unit', tdClass: 'text-right'},
      ],

      //load
      loadpage: true,
    };
  },

  async created() {
    this.loadpage = false
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const id = await urlParams.get('importID')
    await this.getPostcode()
    await this.getTransportType()
    await this.getExpress()
    await this.getCompany()
    await this.viewInfo(id)
    this.loadpage = true
  },

  methods: {
    format_price, formatDatetime, formatDate_thaiShort,
    async getPostcode(){
      if (JSON.parse(localStorage.getItem('postcode'))) {
        this.postcodeMapping = JSON.parse(localStorage.getItem('postcode'))
      } else {
        let response = await axios.get(
          taobaoService_dotnet + 'app/Customer/get-postcode-mapping',
          { headers: header_token }
        );
        response.data.forEach((e) => {
          this.postcodeMapping.push(
            {
              'list': e.postcode + " / " + e.subDistrict + " / " + e.district + " / " + e.province,
              'provinceID': e.provinceID,
              'rowID': e.rowID,
              'subDistrict': e.subDistrict,
              'district': e.district,
              'province': e.province,
              'postcode': e.postcode,
            }
          )
        })
        localStorage.setItem('postcode', JSON.stringify(this.postcodeMapping ))
      }
    },
    async getTransportType() {
      let response = await axios.get(
        taobaoService_dotnet + '/app/order/get-transport-type' ,
        { headers: header_token }
      );
      response.data.forEach((e) => {
        this.transportList.push({
          'text': e.descriptionTH,
          'value': e.id
        })
      })
    },
    async getExpress() {
      let response = await axios.get(
        taobaoService_dotnet + 'api/General/get-express' ,
        { headers: header_token }
      );
      this.expressList = response.data
    },
    async getCompany() {
      let response = await axios.post(
        taobaoService_dotnet + 'app/FileCertificate/get-file-cert',
        // "https://localhost:5001/app/FileCertificate/get-file-cert",
        {
          "customerID": JSON.parse(localStorage.getItem('cusId')),
        },
        { headers: header_token }
      );
      this.companyList = response.data
    },
    async viewInfo(id) {
      this.requestList = []
      this.totalPriceList = []
      let response = await axios.post(
        taobaoService_dotnet + 'app/FileCertificate/view-import-info',
        // "https://localhost:5001/app/FileCertificate/view-import-info",
        {
          "customerID": JSON.parse(localStorage.getItem('cusId')),
          "rowID": id
        },
        { headers: header_token }
      );

      var statList =[]
      var resIm = response.data.importInfo
      var pc = this.postcodeMapping.filter( x => x.rowID == resIm.postcodeMappingID)[0]
      var exp = this.expressList.filter( x => x.rowId == resIm.expressCompanyID)[0]

      response.data.importStatusList.forEach((e) => {
        var check = response.data.statusList.filter( x => x.importStatusID == e.statusID)[0]
        if (check != undefined) {
          statList.push({
            'statusID': e.statusID,
            'statusText': e.statusText,
            'active': true,
            'date': formatDate_thaiShort(check.updateDate)
          })
        } else {
          statList.push({
            'statusID': e.statusID,
            'statusText': e.statusText,
            'active': false,
            'date': ''
          })
        }
      })

      this.requestList.push({
        'requestFormE': response.data.importInfo.requestFormE,
        'requestTaxRefund': response.data.importInfo.requestTaxRefund,
        'requestTransportOwnName': response.data.importInfo.requestTransportOwnName
      })

      this.totalPriceList.push(
        {
          description: 'ภาษีนำเข้า',
          amount: format_price(response.data.importInfo.totalImportDuty),
          unit: 'บาท'
        },
        {
          description: 'ภาษีมูลค่าเพิ่ม (VAT 7%)',
          amount: format_price(response.data.importInfo.totalVat),
          unit: 'บาท'
        },
        {
          description: 'ภาษีนำเข้า',
          amount: format_price(response.data.importInfo.totalShipping),
          unit: 'บาท'
        }
      )

      this.infoList = response.data.importInfo
      this.statList = statList
      this.vCompanyName = this.companyList.filter( x => x.rowID == resIm.companyCertID)[0].companyName
      this.vAddress = resIm.address + ' ' + pc.subDistrict + ' ' + pc.district + ' ' + pc.province + ' ' + pc.postcode
      this.vTransType = this.transportList.filter( x => x.value == resIm.transportTypeID)[0].text + ' - ' + this.makeBoxList.filter( x => x.value == resIm.isMakebox)[0].text
      this.vExpress = exp.rowId == 11 ? resIm.otherExpressName : exp.description
    }
  },
};
</script>

<style lang="scss" scoped>
  .collapsed > .when-opened,
  :not(.collapsed) > .when-closed {
      display: none;
  }
</style>

<style >
  .hidden_header {
    display: none;
  }
</style>